import { TableCompData, ModalCompAdvance } from "../../../../components";
import { EminutesHeader } from "../../../../utils/TableHeader";
import EmptyTable from "../../../../components/Common/EmptyTable";
import useEminuteAction from "../useAdminEminuteActions";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const EminutesList = ({ tableData, isLoading, onViewEminute }) => {
  const navigate = useNavigate();
  const { changeStatus, removeEminute } = useEminuteAction();
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedEminute, setSelectedEminute] = useState(null);
  const handlePublishClick = (data) => {
    setSelectedEminute(data);
    setShowPublishModal(true);
  };

  const handleDeleteClick = (data) => {
    setSelectedEminute(data);
    setShowDeleteModal(true);
  };

  const confirmPublish = () => {
    if (selectedEminute) {
      changeStatus(selectedEminute.id);
      setShowPublishModal(false);
      setSelectedEminute(null);
    }
  };

  const confirmDelete = () => {
    if (selectedEminute) {
      removeEminute(selectedEminute.id);
      setShowDeleteModal(false);
      setSelectedEminute(null);
    }
  };

  const handleEditClick = (data) => {
    navigate(`/super_admin/eminutes/${data.id}`);
  };

  const publishedDropDown = [
    {
      name: "View",
      action: (data) => {
        onViewEminute(data.id);
      },
    },
  ];
  const TableDropDown = [
    {
      name: "View",
      action: (data) => {
        onViewEminute(data.id);
      },
    },
    {
      name: "Edit",
      action: (data) => {
        handleEditClick(data);
      },
    },
    {
      name: "Publish now",
      action: (data) => {
        handlePublishClick(data);
      },
    },
    {
      name: "Delete",
      action: (data) => {
        handleDeleteClick(data);
      },
    },
  ];
  const prepareDropdown = (row) => {
    if (row.status === "PUBLISHED") {
      return publishedDropDown;
    }
    return TableDropDown;
  };
  const publishModalContent = [
    {
      name: "Confirm Publish",
      component: (
        <div className="p-4 text-center">
          <h5 className="mb-3">Publish E-Minute</h5>
          <p className="mb-4">
            Are you sure you want to publish "{selectedEminute?.title}"? This
            will make it visible to all members.
          </p>
          <div className="d-flex gap-3 justify-content-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() => {
                setShowPublishModal(false);
                setSelectedEminute(null);
              }}
            >
              Cancel
            </button>
            <button className="btn btn-primary px-4" onClick={confirmPublish}>
              Publish
            </button>
          </div>
        </div>
      ),
    },
  ];

  const deleteModalContent = [
    {
      name: "Confirm Delete",
      component: (
        <div className="p-4 text-center">
          <h5 className="mb-3 text-danger">Delete E-Minute</h5>
          <p className="mb-4">
            Are you sure you want to delete "{selectedEminute?.title}"? This
            action cannot be undone.
          </p>
          <div className="d-flex gap-3 justify-content-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() => {
                setShowDeleteModal(false);
                setSelectedEminute(null);
              }}
            >
              Cancel
            </button>
            <button className="btn btn-danger px-4" onClick={confirmDelete}>
              Delete
            </button>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <h4 className=" text-black1 fw-bold">E-Minutes List</h4>
      <TableCompData
        data={tableData}
        marginBottom={"120px"}
        columns={EminutesHeader(prepareDropdown)}
        message={
          isLoading ? (
            <div className="py-4">loading...</div>
          ) : (
            <div className="pt-4">
              <EmptyTable
                Message={
                  "E-minute lists is empty, your created minutes will appear here"
                }
              />
            </div>
          )
        }
      />

      <ModalCompAdvance
        show={showPublishModal}
        handleClose={() => {
          setShowPublishModal(false);
          setSelectedEminute(null);
        }}
        arrayComp={publishModalContent}
        centered
        size="md"
      />

      <ModalCompAdvance
        show={showDeleteModal}
        handleClose={() => {
          setShowDeleteModal(false);
          setSelectedEminute(null);
        }}
        arrayComp={deleteModalContent}
        centered
        size="md"
      />
    </div>
  );
};

export default EminutesList;
